export default __webpack_public_path__ + "static/media/were-agil.7c7d8e98.jpg";